// extracted by mini-css-extract-plugin
export var byline = "bj_dr";
export var bylineItem = "bj_ds";